import { useParams } from "react-router"
import { IPETest, PE_TEST_QUESTION_TYPE, PETestQuestion } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import { useEffect, useState } from "react"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { VerticalType } from "src/libs/scalars/interface/IScalarForm"
import Answers from "./Answers"
import useGenTest from "../../hooks/useGenTest"

const Question = () : JSX.Element => {
    const genTest: IPETest = useGenTest()
    const params = useParams()
    const [question, setQuestion] = useState<PETestQuestion>({} as PETestQuestion)
    
    useEffect(() => {
        setQuestion(genTest.questions?.filter(q => q.id === params.question_id)[0] || {})
    }, [params.question_id])

    const onField = (value: any, field: keyof PETestQuestion, data: any) => {
        let q: PETestQuestion = {...question, [field]: value} as PETestQuestion
        setQuestion(q)
        useTestsStore.setState({
            genTest : {
                ...genTest,
                questions: genTest.questions?.map(qu => {
                    if(qu.id === q.id)
                    {
                        return q
                    }
                    return qu
                }) 
            }
        })
    }
    return (
        <div className="px-3 py-2 w-100">
            {/* <div className="lead">
                {question.id}
            </div> */}
            <div className=" py-2 w-100">
                <FieldInput
                    editable
                    type={SCALAR_TYPES.MEDIA}
                    field="thumbnail"
                    //title={__("Thumbnail")}
                    value={question.thumbnail}
                    width={"100%"}
                    height={175}
                    isURLHide
                    notClear
                    onChange={onField}
                />
                <FieldInput
                    editable
                    field="title"
                    //title={__("Title")}
                    value={question.title}
                    placeholder={__("Write question")}
                    onChange={onField}
                /> 
                <FieldInput
                    editable
                    type={SCALAR_TYPES.HTML}
                    field="post_content"
                    //title={__("Description")}
                    value={question.post_content}
                    placeholder={__("Write question commentary")}
                    onChange={onField}
                /> 
                <FieldInput
                    editable
                    type={SCALAR_TYPES.SLIDER}
                    field="hardness"
                    title={__("Hardness")}
                    max={10}
                    stepSize={1}
                    labelStepSize={1}
                    value={question.hardness}
                    // placeholder="Write question commentary"
                    onChange={onField}
                /> 
                <FieldInput
                    editable
                    type={SCALAR_TYPES.TAGS}
                    field="type"
                    title={__("Type")}
                    values={[
                        PE_TEST_QUESTION_TYPE.MULTI_CHOOSE,
                        PE_TEST_QUESTION_TYPE.TRUE_FALSE,
                        PE_TEST_QUESTION_TYPE.MATCHING,
                        PE_TEST_QUESTION_TYPE.RANGE,
                    ]}
                    default={ PE_TEST_QUESTION_TYPE.MULTI_CHOOSE}
                    value={question.type ||  PE_TEST_QUESTION_TYPE.MULTI_CHOOSE}
                    // placeholder="Write question commentary"
                    onChange={onField}
                />
                {
                    question.type === PE_TEST_QUESTION_TYPE.RANGE &&
                    <FieldInput
                        editable
                        type={SCALAR_TYPES.SLIDER}
                        field="range"
                        title={__("Range")}
                        max={10}
                        stepSize={1}
                        labelStepSize={1}
                        value={question.range}
                        // placeholder="Write question commentary"
                        onChange={onField}
                    /> 
                }
                <Answers
                    editable
                    filter={ question.type }
                    vertical={VerticalType.VERTICAL}
                    visualization="test-question-answer" 
                    className={"w-100 m-0 px-0"}
                    field="answers"
                    title={__("Answers")}
                    value={question.answers}
                    onChange={onField}
                />
            </div>
        </div>
    )
} 

export default Question